import { render, staticRenderFns } from "./EmailWorkflowPage.vue?vue&type=template&id=bb62955c&scoped=true"
import script from "./EmailWorkflowPage.vue?vue&type=script&lang=js"
export * from "./EmailWorkflowPage.vue?vue&type=script&lang=js"
import style0 from "./EmailWorkflowPage.vue?vue&type=style&index=0&id=bb62955c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62955c",
  null
  
)

export default component.exports